export default {

  penaltiesContainer:{
    //paddingBottom:'20px',
  },
  resizePenaltiesContainer: {
    '@media (min-width: 801px)': {
      margin: '0 30px',
    }
  },
  penaltiesContent:{
    backgroundColor: '#F3F2EF',
  },
  penaltiesTitle:{
    color: data => data.mainColor,
    font: data => '700 11px ' + data.fontFamily1,
    display:'block'
  },
  penaltiesText:{
    font: data => '400 11px ' + data.fontFamily1,
    color: '#000'
  },
  penaltiesBlock: {
    display: 'flex',
    flexDirection: 'column',
    padding: '15px 30px',
    background: '#F1F2EF',
    gap: '5px',
  },
  fontSize12:{
      fontSize: '12px'
  }
}